import { LeavePageModal } from '@adotel/components'

import { TemplateAddHeader } from './TemplateAddHeader'
import { TemplateDetails } from './TemplateDetails'
import useStyles from './styles/index.styles'

const TemplateForm = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <LeavePageModal />
      <TemplateAddHeader />
      <div className={classes.stepsContentContainer}>
        <TemplateDetails />
      </div>
    </div>
  )
}

export default TemplateForm
